import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useParams } from "react-router-dom";
import { getUsuarioDetalle, getUsuarioDetalleTransacciones, postUpdateUsuario } from "../../../api/ApiService";
import PerfilDetalleComponents from "./components/PerfilDetalleComponents";


function DetalleUsuarioPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loading, setLoading] = useState(false);

    const [dataUsuario, setDataUsuario] = useState(null);
    const [dataResumen, setDataResumen] = useState(null);
    const [dataGiftCard, setDataGiftCard] = useState(null);
    const [perPage, setPerPage] = useState(5);
    const [transacciones, setTransacciones] = useState([]);


    const stateToken = useSelector(state => state.reducerGlobal.token);


    const params = useParams();

    const { id } = params;
    // console.log("id", id);


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleUsuarioDetalle();
                handleUsuarioDetalleTransacciones();
            }
        }
    }, [id, stateToken, perPage]);




    //==========================================================funcion para enviar encuesta a la api
    const handleUsuarioDetalleTransacciones = () => {
        let body = {
            id: id,
        }


        getUsuarioDetalleTransacciones(stateToken?.access_token, body)
            .then(response => {
                // console.log("getUsuarioDetalleTransacciones", response?.data?.transacciones);
                setTransacciones(response?.data?.transacciones || []);

            })
            .catch(error => {
                console.log("error-getUsuarioDetalle", error);
                setLoading(false);
                setCargando(true);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }


    //==========================================================funcion para enviar encuesta a la api
    const handleUsuarioDetalle = (pageToLoad = 1, perPageToLoad = perPage) => {
        let body = {
            id: id,
            canjes_per_page: perPageToLoad,
            canjes_page: pageToLoad
        }


        getUsuarioDetalle(stateToken?.access_token, body)
            .then(response => {
                // console.log("getUsuarioDetalle", response);
                setCargando(true);
                setLoading(false);

                setDataGiftCard(response?.data?.giftcards_canjes || {});

                setDataUsuario(response?.data?.usuario || null);
                setDataResumen(response?.data?.cliente_resumen || null);

            })
            .catch(error => {
                console.log("error-getUsuarioDetalle", error);
                setLoading(false);
                setCargando(true);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };
















    const handlePageChange = (nextPage) => {
        if (!dataGiftCard?.last_page) return;
        if (nextPage < 1 || nextPage > dataGiftCard.last_page) return;
        setLoading(true);

        handleUsuarioDetalle(nextPage, perPage);
    };


    const handlePerPageChange = (nextPerPage) => {
        setPerPage(nextPerPage);
        setLoading(true);

        handleUsuarioDetalle(1, nextPerPage);

    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">Perfil</h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden p-6">
                            <PerfilDetalleComponents

                                handleCancelar={handleCancelar}

                                dataUsuario={dataUsuario}
                                dataGiftCard={dataGiftCard}
                                dataResumen={dataResumen}
                                transacciones={transacciones}

                                onPageChange={handlePageChange}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}

                            />
                        </div>
                    ) :
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Backdrop open={loading} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default DetalleUsuarioPage;